import MenuItem from 'material-ui/MenuItem';
import React, {Component} from 'react';
import SelectField from 'material-ui/SelectField';
import TextField from 'material-ui/TextField';

import {HeadlineH1} from './text/Headlines';
import {RCol, Row} from './Grid';
import {TopBar, TopBarButton, TopBarLeftCol} from './form/FormElements';
import ActionButtonRow from '../components/ActionButtonRow';
import ErrorMessage from '../components/ErrorMessage';
import filterOutNotDefinedValues from '../helpers/filterOutNotDefinedValues';

export const USER_STATUS_NEW = 'new';
export const USER_STATUS_ACTIVE = 'active';
export const USER_STATUS_INACTIVE = 'inactive';

export default class extends Component {
  constructor(props) {
    super(props);
    let data = {};
    if (props.data) {
      data = props.data;
    }
    this.state = {
      email: '',
      phone: '',
      firstName: '',
      lastName: '',
      password: '',
      city: '',
      street: '',
      company: '',
      userStatus: 'new',
      role: 'Prospect',
      changePassword: false,
      ...filterOutNotDefinedValues(data.user),
    };
  }

  componentWillReceiveProps = newProps => {
    if (newProps.data.error) {
      const {graphQLErrors} = newProps.data.error || {};
      this.setState({errors: graphQLErrors});
    } else {
      const {user} = newProps.data || {};
      this.setState({errors: [], ...filterOutNotDefinedValues(user)});
    }
  };
  _goBackToList = () => this.props.history.replace('/users');

  _renderHeadline = () => {
    if (this._isNew()) {
      return <HeadlineH1>Neuer Benutzer</HeadlineH1>;
    }
    return <HeadlineH1>Benutzer bearbeiten</HeadlineH1>;
  };

  _isNew = () => !this.props.match.params.id;

  _save = () =>
    this.props
      .save({...this.state})
      .then(() => this._goBackToList())
      .catch(error => {
        console.log('there was an error sending the query', error);
      });

  render() {
    let {
      email,
      phone,
      firstName,
      lastName,
      street,
      city,
      company,
      password,
      role,
      changePassword,
      userStatus,
    } = this.state;

    return (
      <div>
        <TopBar>
          <Row>
            <TopBarLeftCol size={0.3} style={{paddingLeft: 100}}>
              {this._renderHeadline()}
            </TopBarLeftCol>
            <RCol size={0.7}>
              <TopBarButton onClick={this._goBackToList} label="Zurück zur Übersicht" />
              {/*{!this.isNew() && <FlatButton onClick={() => this.setState({deleteModalOpen: true})} label="löschen" />}*/}
              {!this._isNew() && (
                <TopBarButton onClick={() => this.setState({changePassword: true})} label="Passwort ändern" />
              )}
              <TopBarButton primary onClick={this._save} label="speichern" />
            </RCol>
          </Row>
        </TopBar>
        <ErrorMessage errors={this.state.errors} />
        <TextField
          type="text"
          fullWidth={true}
          floatingLabelText="Vorname*"
          value={firstName}
          onChange={({target: {value}}) => this.setState({firstName: value})}
        />
        <TextField
          type="text"
          fullWidth={true}
          floatingLabelText="Nachname*"
          value={lastName}
          onChange={({target: {value}}) => this.setState({lastName: value})}
        />
        <TextField
          type="text"
          fullWidth={true}
          floatingLabelText="Email*"
          value={email}
          onChange={({target: {value}}) => this.setState({email: value})}
        />
        <TextField
          type="text"
          fullWidth={true}
          floatingLabelText="Telefonnummer"
          value={phone}
          onChange={({target: {value}}) => this.setState({phone: value})}
        />
        <TextField
          type="text"
          fullWidth={true}
          floatingLabelText="Firma"
          value={company}
          onChange={({target: {value}}) => this.setState({company: value})}
        />
        <TextField
          type="text"
          fullWidth={true}
          floatingLabelText="Straße, Hausnummer"
          value={street}
          onChange={({target: {value}}) => this.setState({street: value})}
        />
        <TextField
          type="text"
          fullWidth={true}
          floatingLabelText="PLZ, Org"
          value={city}
          onChange={({target: {value}}) => this.setState({city: value})}
        />
        <SelectField
          floatingLabelText="Rolle"
          fullWidth={true}
          value={role}
          onChange={(_, __, value) => this.setState({role: value})}>
          <MenuItem value="User" primaryText="Benutzer" />
          <MenuItem value="Editor" primaryText="Editor" />
          <MenuItem value="Admin" primaryText="Admin" />
        </SelectField>
        <SelectField
          floatingLabelText="Status"
          fullWidth={true}
          value={userStatus}
          onChange={(_, __, value) => this.setState({userStatus: value})}>
          <MenuItem value={USER_STATUS_NEW} primaryText="Neu" />
          <MenuItem value={USER_STATUS_ACTIVE} primaryText="Aktiv" />
          <MenuItem value={USER_STATUS_INACTIVE} primaryText="Inaktiv" />
        </SelectField>
        {(this._isNew() || changePassword) && (
          <TextField
            type="password"
            fullWidth={true}
            floatingLabelText="Passwort*"
            value={password}
            onChange={({target: {value}}) => this.setState({password: value})}
          />
        )}

        <ActionButtonRow />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/UserForm.js